<template>
  <div role="presentation" class="tour explore-campus" :class="{'map-open': isMapOpen}">
    <header-mobile>
      <h3>{{ $t('message.exploreCampus') }}</h3>
    </header-mobile>
    <main class="content" aria-label="Main content">
      <GeoLocationNotification />
      <div
        v-if="description"
        v-html="$tr(description)"
        role="presentation"
        class="description"
      ></div>
      <div
        v-else
        role="presentation"
        class="description"
      >
        <p>{{ $t("exploreCampus.description1") }}</p>
      </div>
      <div class="btn-container" role="presentation">
        <button
          class="btn btn-primary main-background secondary-text"
          @click="isMapOpen = !isMapOpen"
        >
          <i aria-hidden="true" class="material-icons">map</i>
          <span v-if="isMapOpen">{{ $t("exploreCampus.listView") }}</span>
          <span v-else>{{ $t("exploreCampus.mapView") }}</span>
        </button>
      </div>
      <div class="search" role="presentation">
        <input
          ref="searchInput"
          :placeholder="$t('button.search')"
          v-on:keyup.enter="updatePOIs()"
          v-model='search'
          type="text"
          name="Search"
        >
        <button class="btn btn-primary main-background" @click="updatePOIs()"><i aria-hidden="true" class="material-icons">search</i></button>
      </div>
      <poi-map :poiList="poiList"
               :position="position"
               :markerPopup="true"
               :visible="isMapOpen"
               :height="'500px'" />
      <vue-pull-refresh :on-refresh="onRefresh">
        <poi-list :poiList="poiList" v-show="!isMapOpen"/>
      </vue-pull-refresh>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import HeaderMobile from '@/components/HeaderMobile'
import PoiList from '@/components/PoiList'
import PoiMap from '@/components/PoiMap'
import VuePullRefresh from 'vue-pull-refresh'
import GeoLocationNotification from '@/components/GeoLocationNotification'

export default {
  name: 'ExploreCampus',
  components: {
    'header-mobile': HeaderMobile,
    'vue-pull-refresh': VuePullRefresh,
    PoiList,
    PoiMap,
    GeoLocationNotification
  },
  data: function () {
    return {
      search: '',
      isMapOpen: false
    }
  },
  created () {
    this.updatePOIs()
  },
  mounted () {
    this.searchInputFocus()
  },
  computed: {
    ...mapState({
      description: state => state.college.settings.explore_page.description
    }),
    ...mapState('explore', {
      poiList: state => state.poiList
    }),
    ...mapGetters({
      position: 'getUserPosition'
    })
  },
  methods: {
    ...mapActions('explore', [
      'getPOIs'
    ]),
    ...mapMutations('poi', ['setCurrentPoiList']),
    ...mapMutations(['startLoad', 'endLoad']),
    updatePOIs () {
      this.startLoad()
      this.getPOIs({ 'needle': this.search }).then(() => {
        this.endLoad()
        this.setCurrentPoiList(this.poiList)
      }).catch(() => {
        this.endLoad()
      })
    },
    onRefresh: function () {
      return this.updatePOIs()
    },
    searchInputFocus () {
      if (this.$route.query.search_focus) {
        this.$refs.searchInput.focus()
      } else {
        document.body.focus()
      }
    }
  },
  watch: {
    position: function (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.updatePOIs()
      }
    },
    $route () {
      this.searchInputFocus()
    }
  }
}
</script>
